const config = {
  baseURL: "/panvel/api",
  timeout: 100000
}

const urlConfirmacaoCompra = "confirmacaoCompra.do";
  
export {
  config,
  urlConfirmacaoCompra
};


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/config/production.js